var render, staticRenderFns
import script from "./RatioContaier.vue?vue&type=script&lang=js&"
export * from "./RatioContaier.vue?vue&type=script&lang=js&"
import style0 from "./RatioContaier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cb58eb4')) {
      api.createRecord('3cb58eb4', component.options)
    } else {
      api.reload('3cb58eb4', component.options)
    }
    
  }
}
component.options.__file = "src/components/GroupTeams/Common/RatioContaier.vue"
export default component.exports